const app = {
	title: 'Plateforme Otipass',
	subtitle: 'Formulaire de configuration de votre plateforme',
	langFr: 'Français',
	langEn: 'English',
	langSelectLabel: 'Langue',
	logoAlt: 'Logo Otipass',
	nav: {
		step: 'Étape',
		previous: 'Précédent',
		next: 'Suivant',
		recap: 'Récapitulatif',
		send: 'Envoyer',
		save: 'Enregistrer',
	},
	jsonImport: {
		button: 'Charger un fichier JSON',
		aria: 'Charger un fichier JSON pour préremplir le formulaire',
	},
	alerts: {
		readFile: 'Impossible de lire le fichier.',
		jsonObject: 'Le fichier JSON doit contenir un objet (pas un tableau ou une valeur simple).',
		jsonInvalid: 'Fichier JSON invalide. Vérifiez le format.',
		readError: 'Erreur lors de la lecture du fichier.',
		submitError: 'Erreur lors de la soumission du formulaire.',
	},
	breadcrumb: {
		1: 'Projet',
		2: 'Émetteur',
		3: 'Services',
		4: 'Données touristiques',
		5: 'Visuel & support',
		6: 'Lecteurs',
		7: 'Site web',
		8: 'Réseaux sociaux',
		9: 'Inscriptions & boutique',
		10: 'Finances',
		11: 'Langues & divers',
		12: 'Contacts',
		13: 'Formules',
		14: 'Récapitulatif',
	},
	common: {
		yes: 'Oui',
		no: 'Non',
		none: 'aucun',
		other: 'Autre',
		noneF: 'Aucun',
		modify: 'Modifier',
		example: 'Exemple : {{text}}',
		dash: '—',
		europe: 'Europe',
		requiredFields: 'obligatoire',
	},
};

export default app;
